module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("vux-loader 使用")]), _vm._v(" "), _c('h2', [_vm._v("安装")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm install vux-loader --save-dev\n")])]), _vm._v(" "), _c('h2', [_vm._v("使用")]), _vm._v(" "), _c('p', [_vm._v("为了降低使用成本及不侵入原来配置，只需要调用"), _c('code', [_vm._v("merge")]), _vm._v("方法对原来"), _c('code', [_vm._v("webpack")]), _vm._v("配置进行操作：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" webpackConfig = {} "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 原来的 webpack.base.js 配置")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" vuxLoader = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-loader'")]), _vm._v(")\n\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("module")]), _vm._v(".exports = vuxLoader.merge(webpackConfig, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("options")]), _vm._v(": {},\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("plugins")]), _vm._v(": [{\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-ui'")]), _vm._v("\n  }]\n})\n")])]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("更新配置后需要重新运行 "), _c('code', [_vm._v("npm run dev")]), _vm._v(" 命令。")])]), _vm._v(" "), _c('h2', [_vm._v("Options")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("env")]), _vm._v(" 非必选，定义当前环境变量，只在 vux-loader 里使用，用来判断哪些插件需要被执行(如果plugin有定义envs的话)，目的是实现一份配置多个环境使用。")])]), _vm._v(" "), _c('h2', [_vm._v("Plugins")]), _vm._v(" "), _c('p', [_vm._v("插件为一个数组列表，根据需要可以添加你需要的插件，插件名为必须，有些组件不需要额外配置选项。")]), _vm._v(" "), _c('p', [_vm._v("公用参数为:")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("name")]), _vm._v(" "), _c('code', [_vm._v("必须")]), _vm._v("，插件名字")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("envs")]), _vm._v(" "), _c('code', [_vm._v("非必须")]), _vm._v("，数组，当前插件在哪些环境变量里执行，不定义则默认执行")])]), _vm._v(" "), _c('p', [_vm._v("下面的插件配置代码将省略 "), _c('code', [_vm._v("plugins:[]")]), _vm._v("的书写。")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("当使用默认配置时，可以使用简写")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("plugins: ["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-ui'")]), _vm._v("]\n")])]), _vm._v(" "), _c('p', [_vm._v("等同于")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("plugins: [{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-ui'")]), _vm._v("\n}]\n")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-12a57fe6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-12a57fe6"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/install-187.vue
// module id = 2043
// module chunks = 431